import { reportInfo } from '@ms/yammer-data/dist/telemetry';
import { InfoEventName } from '@ms/yammer-telemetry';

import { isIFrame } from '../iframe';

import { isUnpartitionedThirdPartyCookieSupported } from './isUnpartitionedThirdPartyCookieSupported';

export const reportThirdPartyCookieEvent = () => {
  const isExecutingInIFrame = isIFrame();
  const isThirdPartyCookieEnabled = isUnpartitionedThirdPartyCookieSupported();

  reportInfo({
    eventName: InfoEventName.ThirdPartyCookieSetAttempt,
    eventProperties: {
      success: isThirdPartyCookieEnabled,
      isExecutingInIFrame,
    },
  });
};
